// const serverPath = 'http://localhost:8000';
// const serverPath = 'https://projects.dimofinf.net/buffet';
const serverPath = 'https://api.buffet.top2top.net';
// const serverPath = 'http://192.168.88.102:8000';
// export const UserImgPath = serverPath +'/uploads/users/'
export default serverPath

